import React from 'react';
import { Card } from '@nimbus-ds/components';
import { LanguagesType } from 'App/i18n';
import { TabsMultiLanguage, Stack } from 'commons/components';
import InputsTitleAndContent from './InputsTitleAndContent';
import { InputsTitleAndContentProps } from './InputsTitleAndContent/InputsTitleAndContent';

type TitleAndContentCardProps = Readonly<
  InputsTitleAndContentProps & {
    bottomContent?: React.ReactNode;
  }
>;

const TabsContent = React.memo(
  ({ bottomContent, ...rest }: TitleAndContentCardProps) => (
    <Stack column spacing="base" align="stretch">
      <InputsTitleAndContent {...rest} />
      {bottomContent}
    </Stack>
  ),
);

TabsContent.displayName = 'TabsContent';

function TitleAndContentCard(props: Readonly<TitleAndContentCardProps>) {
  const missingLanguages = Object.keys(props.errors)
    .filter((err) => err.startsWith('title') || err.startsWith('content'))
    .map((err) => err.split('.')[1]);

  return (
    <Card>
      <Card.Body>
        <TabsMultiLanguage
          initialLanguage={missingLanguages[0] as LanguagesType}
        >
          <TabsContent {...props} />
        </TabsMultiLanguage>
      </Card.Body>
    </Card>
  );
}

export default TitleAndContentCard;
